import { Injectable } from '@angular/core';
import { DcSessionStorage } from '@datachain/ui-sdk/common';

@Injectable({
	providedIn: 'root',
})
export class ConnectionStorage extends DcSessionStorage<{ routeUrl: string }> {
	protected key = 'connection';
	public constructor() {
		super();
	}

	public setRouteUrl(routeUrl: string): void {
		this.setStorage({
			routeUrl,
		});
	}

	public getRouteUrl(): string | undefined {
		return this.getStorage()?.routeUrl ?? undefined;
	}

	public clear(): void {
		this.removeFromStorage();
	}
}
